module.exports = __webpack_public_path__ + "img/智能客服系统.27a44ff7.png";